import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ChevronRight } from "lucide-react";

// items: [{ label, to }] — last item is the current page (no link)
export const Breadcrumbs = ({ items, hideBack = false }) => {
  const parent = !hideBack && items[items.length - 2];
  return (
    <nav className="flex flex-wrap items-center gap-x-3 gap-y-2 text-sm" aria-label="Breadcrumb" data-testid="breadcrumbs">
      {parent && (
        <Link to={parent.to} className="inline-flex items-center gap-1.5 rounded-full border border-border px-3 py-1 text-muted-foreground transition-colors hover:border-primary hover:text-primary" data-testid="breadcrumb-back">
          <ArrowLeft size={14} /> Back to {parent.label}
        </Link>
      )}
      <ol className="flex flex-wrap items-center gap-1 text-muted-foreground">
        {items.map((it, i) => (
          <li key={it.label} className="flex items-center gap-1">
            {i > 0 && <ChevronRight size={13} className="opacity-50" />}
            {i < items.length - 1
              ? <Link to={it.to} className="hover:text-primary" data-testid={`breadcrumb-${i}`}>{it.label}</Link>
              : <span className="text-foreground" data-testid="breadcrumb-current">{it.label}</span>}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export const CourseTabs = ({ instrument, currentId }) => {
  const courses = [...instrument.courses, ...(instrument.miniCourses || [])];
  return (
    <div className="sticky top-[65px] z-40 -mx-4 mt-6 border-b border-border bg-background/85 px-4 py-3 backdrop-blur-xl sm:-mx-8 sm:px-8" data-testid="course-tabs">
      <div className="flex gap-2 overflow-x-auto">
        <span className="hidden shrink-0 self-center pr-1 font-mono text-[10px] uppercase tracking-widest text-muted-foreground sm:block">{instrument.label} courses</span>
        {courses.map((c) => {
          const active = c.id === currentId;
          return (
            <Link key={c.id} to={`/courses/${instrument.id}/${c.id}`} data-testid={`course-tab-${c.id}`} aria-current={active ? "page" : undefined}
              className={`shrink-0 rounded-full border px-4 py-1.5 text-sm transition-colors ${active ? "border-primary bg-primary text-primary-foreground" : "border-border bg-card text-muted-foreground hover:border-primary hover:text-foreground"}`}>
              {c.mini ? c.title : `${c.from} → ${c.to}`}
            </Link>
          );
        })}
      </div>
    </div>
  );
};
